import { render } from "./ProductCategories.vue?vue&type=template&id=6a0c7b36&scoped=true"
import script from "./ProductCategories.vue?vue&type=script&lang=js"
export * from "./ProductCategories.vue?vue&type=script&lang=js"

import "./ProductCategories.vue?vue&type=style&index=0&id=6a0c7b36&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0c7b36"]])

export default __exports__